import React from 'react';
import { useModule } from '../../context/ModuleContext';
import CashierLayout from '../../components/CashierLayout';
import RestaurantOrderPage from '../../modules/restaurant/pages/Orders/RestaurantOrderPage';
import SalesInvoiceCreatePage from '../../modules/sales/pages/SalesInvoice/SalesInvoiceCreatePage';

/**
 * Cashier order entry point — renders the correct POS based on the company's
 * business-vertical module:
 *   • restaurant        → restaurant order POS (KOT/tables)
 *   • car rental        → no cashier POS (bookings are not a counter-sale flow)
 *   • everything else   → the generic Sales create-and-pay POS. All Sales-app
 *     verticals (automobile, retail, pharmacy, …) sell through sales invoices.
 */
const CashierOrderPage: React.FC = () => {
  const { company } = useModule();
  const module = company?.moduleCode?.toLowerCase() ?? '';

  if (module === 'restaurant') {
    return (
      <CashierLayout>
        <RestaurantOrderPage cashierMode />
      </CashierLayout>
    );
  }

  if (module !== 'carrental') {
    return (
      <CashierLayout>
        <SalesInvoiceCreatePage cashierMode />
      </CashierLayout>
    );
  }

  return (
    <CashierLayout>
      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', height: '60vh',
        color: 'var(--ims-text-sub)', fontSize: 14,
      }}>
        <div style={{ fontSize: 40, marginBottom: 12, opacity: 0.4 }}>🏪</div>
        <div style={{ fontWeight: 600, marginBottom: 4 }}>
          No POS available for this module
        </div>
        <div style={{ fontSize: 12 }}>Module: {company?.moduleCode ?? 'unknown'}</div>
      </div>
    </CashierLayout>
  );
};

export default CashierOrderPage;
